import React, { Component } from "react";
import "./styles.css";
import Loader from "../../prefabs/loader/view";
import Icon from "../../prefabs/icon/view";

class PopupBox extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.handleButtonConfirmClick = this.handleButtonConfirmClick.bind(this);
    this.handleButtonCancelClick  = this.handleButtonCancelClick.bind(this);

    this.handleCloseClick  = this.handleCloseClick.bind(this);
    this.handleInnerClick  = this.handleInnerClick.bind(this);

    this.state = {
      open: false,
      lock: false,
    };



    this.cachedId      = null;

    this.cachedType    = null;
    this.cachedCode    = null;
    this.cachedLock    = null;

    this.cachedHeading = null;
    this.cachedMessage = null;

    this.cachedConfirm = null;
    this.cachedCancel  = null;
  }



  // ===============================================================================================
  // Handle when the confirm button is clicked (and run callback if required)
  handleButtonConfirmClick(e) {
    e.preventDefault();
    // console.log("POPUP:\n Clicked confirm button");
    if (this.cachedConfirm.func) { this.cachedConfirm.func(); }
    if (!this.state.lock) { this.setState({ open: false }); }
  }



  // ===============================================================================================
  // Handle when the cancel button is clicked (and run callback if required)
  handleButtonCancelClick(e) {
    e.preventDefault();
    // console.log("POPUP:\n Clicked cancel button");
    if (this.cachedCancel.func) { this.cachedCancel.func(); }
    if (!this.state.lock) { this.setState({ open: false }); }
  }



  // ===============================================================================================
  // Handle closing the popup (via close button, or black overlay)
  handleCloseClick(e) {
    e.preventDefault();
    if (!this.state.lock) {
      // console.log("POPUP:\n Clicked background");
      this.setState({ open: false });
    }
  }



  // ===============================================================================================
  // This click event stops the popup from closing (when clicking on the box itself)
  handleInnerClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    // Check if we have new popup info
    let conf = this.props.config;
    if (conf) {
      if (conf.id && this.cachedId !== conf.id) {
        // console.log("POPUP:\n Creating a new popup: ", conf);

        this.cachedId      =  conf.id;
        this.cachedType    = (conf.type)    ? conf.type    : "standard";
        this.cachedCode    = (conf.code)    ? conf.code    : null;
        this.cachedLock    = (conf.lock)    ? conf.lock    : false;

        this.cachedHeading = (conf.heading) ? conf.heading : null;
        this.cachedMessage = (conf.message) ? conf.message : null;

        this.cachedConfirm = null;
        this.cachedCancel  = null;

        if (conf.confirmBttn) {
          this.cachedConfirm = {
            label: conf.confirmBttn,
            func:  (typeof conf.confirmFunc === "function") ? conf.confirmFunc : null,
            type:  conf.confirmType,
          };
        }

        if (conf.cancelBttn) {
          this.cachedCancel = {
            label: conf.cancelBttn,
            func:  (typeof conf.cancelFunc === "function") ? conf.cancelFunc : null,
            type:  conf.cancelType,
          };
        }

        // Trigger the popup to open
        setTimeout(() => {
          this.setState({ open: true, lock: this.cachedLock });
        }, 1);
      }
    }




    // ---------------------------------------------------------------------------------------------
    // Generate error code
    let viewErrorCode = null;

    if (this.cachedCode) {
      viewErrorCode = (
        <div className="popup-box-inner popup-box-inner--errorcode">
          <span className="popup-error-message"> Error code: </span>
          <span className="popup-error-code"> {this.cachedCode.toUpperCase()} </span>
        </div>
      );
    }



    // ---------------------------------------------------------------------------------------------
    // Generate close button
    let viewCloseButton = null;

    if (!this.state.lock) {
      viewCloseButton = (
        <div className="popup-box-inner popup-box-inner--close-btn">
          <button className="popup-close-btn" onClick={this.handleCloseClick}>
            <Icon type="close-b" />
          </button>
        </div>
      );
    }



    // ---------------------------------------------------------------------------------------------
    // Generate buttons
    let viewButtonConfirm = null;
    let viewButtonCancel  = null;

    if (this.cachedConfirm) {
      viewButtonConfirm = (
        <div className="popup-box-inner popup-box-inner--button">
          <button className={"maccas-btn" +
            ((this.cachedConfirm.type) ? " maccas-btn--" + this.cachedConfirm.type : "")}
            onClick={this.handleButtonConfirmClick}>
            {this.cachedConfirm.label}
          </button>
        </div>
      );
    }

    if (this.cachedCancel) {
      viewButtonCancel = (
        <div className="popup-box-inner popup-box-inner--button">
          <button className={"maccas-btn" +
            ((this.cachedCancel.type) ? " maccas-btn--" + this.cachedCancel.type : "")}
            onClick={this.handleButtonCancelClick}>
            {this.cachedCancel.label}
          </button>
        </div>
      );
    }



    // ---------------------------------------------------------------------------------------------
    // Generate actual popup box
    let viewPopupBox = (
      <div className="popup-loader">
        <Loader type="thick" />
      </div>
    );

    if (this.cachedType !== "loader") {
      viewPopupBox = (
        <div className={"popup-box" +
          ((this.cachedType) ? " popup-box--" + this.cachedType : "")}
          onClick={this.handleInnerClick}>

          {viewCloseButton}

          <div className={"popup-box-inner popup-box-inner--heading" +
            ((!this.cachedHeading) ? " popup-box-inner--hidden" : "")}>
            <h1>{this.cachedHeading}</h1>
          </div>

          <div className={"popup-box-inner popup-box-inner--message" +
            ((!this.cachedMessage) ? " popup-box-inner--hidden" : "")}>
            {this.cachedMessage}
          </div>

          {viewButtonConfirm}
          {viewButtonCancel}

          {viewErrorCode}

        </div>
      );
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className={"popup-box-container" +
        ((this.state.open) ? " popup-box-container--shown" : "")}
        onClick={this.handleCloseClick}>

        {viewPopupBox}

      </div>
    );
  }

}



export default PopupBox
